/**
 * Formatea cualquier error de la API a un mensaje seguro para mostrar al usuario.
 *
 * Maneja todos los casos que devuelve nuestro backend (FastAPI/Pydantic):
 *  - 422 con `detail: [{type, loc, msg, ...}]` → une todos los `msg` con ", "
 *  - 4xx con `detail: "string"` → usa el string
 *  - 4xx con `detail` objeto/null/undefined → cae al `fallback`
 *  - Cualquier otra cosa → `fallback`
 *
 * Importante: NUNCA devuelve un objeto. Solo strings.
 * Esto previene el crash "Objects are not valid as a React child" cuando se
 * pasa el resultado directo a toast/Sonner.
 *
 * Uso típico:
 *   } catch (err) {
 *     toast.error(formatApiError(err, 'Error al guardar usuario'));
 *   }
 */
export function formatApiError(error, fallback = 'Ocurrió un error inesperado') {
  const detail = error?.response?.data?.detail;

  // 1) Array de errores Pydantic v2
  if (Array.isArray(detail)) {
    const messages = detail
      .map((e) => {
        if (typeof e === 'string') return e;
        if (e && typeof e === 'object') {
          return e.msg || e.message || e.detail || null;
        }
        return null;
      })
      .filter(Boolean);
    if (messages.length > 0) return messages.join(', ');
    return fallback;
  }

  // 2) String directo (la mayoría de los HTTPException(detail="..."))
  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  // 3) Mensaje genérico del browser / network
  if (typeof error?.message === 'string' && error.message && !error.response) {
    return error.message;
  }

  // 4) Fallback seguro
  return fallback;
}

export default formatApiError;
